import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';

import { ErrorcontrolService } from 'basecomponents';
import { Observable, ReplaySubject, Subject, Subscription, timer } from 'rxjs';
import { Notification } from './notification.model';

export interface INotifyMessage {
  /**
   * the key of message. It can be an string like type 'version_update' or the id of the message parent subscribers need to know what expect
    */
  id: string;
  type: string;//ANY,STRING
  message: any;
  messagestr: string;
  date: Date;
}

@Injectable({
  providedIn: 'root'
})
export class NotifyService implements OnDestroy {

  randomGeneration: boolean;
  notifications$: Observable<Notification[]>;

  private notificationsSubject: ReplaySubject<Notification[]>;
  private notifications = new Array<Notification>();
  private randomSub: Subscription;

  constructor() {
    this.notificationsSubject = new ReplaySubject<Notification[]>(1);
    this.notifications$ = this.notificationsSubject.asObservable();  
    //this.startRandomGeneration();  
  }

  ngOnDestroy() {
    console.log("NotifyService onDestroy");
  }


  startRandomGeneration() {
    this.randomSub = timer(5000,3000).subscribe(() => {
      let notification = this.createRandomNotification();
      this.addNotification(notification);
    })
  }

  stopRandomGeneration() {
    if (this.randomSub !== undefined) {
      this.randomSub.unsubscribe();
    }
  }

  addNotification(notification: Notification) {
    this.notifications = [...this.notifications, notification];
    this.notificationsSubject.next(this.notifications);
  }

  removeNotification(id: string) {
    this.notifications = this.notifications.filter((x) => x.id !== id);
    this.notificationsSubject.next(this.notifications);
  }

  clearNotifications() {
    this.notifications = new Array<Notification>();
    this.notificationsSubject.next(this.notifications);
  }

  createRandomNotification(): Notification {
    let notification: Notification = new Notification();

    notification.type = "INFO";
    notification.message = "MESSAGE-" + notification.date;
    return notification;
  }

}

